// Aceleres: a aba do painel fica aberta por horas e continua executando o
// bundle com que abriu. O HTML revalida e os assets têm hash, mas nada obriga
// a aba a buscá-los de novo — e como o build preserva os chunks antigos no
// disco, o `vite:preloadError` nunca dispara. Aqui a aba compara o próprio
// entry com o do manifesto publicado e, havendo build novo, troca na próxima
// navegação (recarregar no meio de uma digitação ou envio perderia estado).
const MANIFEST_URL = '/vite/.vite/manifest.json';
const ENTRY_KEY = 'entrypoints/dashboard.js';
const CHECK_INTERVAL = 5 * 60 * 1000;

const currentEntryFile = entryUrl => {
  const match = String(entryUrl || '').match(/\/vite\/(assets\/[^?#]+\.js)/);
  return match ? match[1] : null;
};

export const initializeStaleBundleReload = ({ router, entryUrl }) => {
  const current = currentEntryFile(entryUrl);
  // Em desenvolvimento o entry é servido pelo vite, sem manifesto.
  if (!current) return;

  let stale = false;
  let checking = false;

  const check = async () => {
    if (stale || checking) return;
    checking = true;
    try {
      const response = await fetch(MANIFEST_URL, { cache: 'no-store' });
      if (!response.ok) return;
      const manifest = await response.json();
      const published = manifest?.[ENTRY_KEY]?.file;
      if (published && published !== current) stale = true;
    } catch (error) {
      // Rede instável não é build novo; tenta de novo no próximo ciclo.
    } finally {
      checking = false;
    }
  };

  router.beforeEach((to, from) => {
    if (!stale || !from.name) return true;
    window.location.assign(to.fullPath);
    return false;
  });

  setInterval(check, CHECK_INTERVAL);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });
  check();
};
